import NavigationV2 from './NavigationV2';
export default NavigationV2;
